import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const ITEMS = [
  'Se sentir linda(o) novamente',
  'Vestir aquela roupa que está parada no armário.',
  'Tirar fotos sem tentar esconder o corpo.',
  'Receber elogios',
  'Se olhar no espelho e gostar do que vê.'
];

const ImagineSection = () => {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="imagine" className="mgs-imagine">
      <div className="mgs-imagine__inner">
        <div className="mgs-imagine__text">
          <h2 className="mgs-imagine__title">Imagine voltar a…</h2>

          <ul className="mgs-imagine__list">
            {ITEMS.map((item, i) => (
              <li key={i} className="mgs-imagine__item">
                <i className="fas fa-check"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <button className="mgs-imagine__cta" onClick={scrollToOffer}>
            <i className="fas fa-tint"></i>
            QUERO EMAGRECER AGORA
          </button>
        </div>

        <div className="mgs-imagine__image">
          <img
            src={IMAGE_PATHS.mulherImagine}
            alt="Mulher feliz com o resultado"
            className="mgs-imagine__img"
          />
        </div>
      </div>
    </section>
  );
};

export default ImagineSection;
